import { render } from "./AcceptanceHistoryDetail.vue?vue&type=template&id=93bab6fc&scoped=true"
import script from "./AcceptanceHistoryDetail.vue?vue&type=script&lang=ts"
export * from "./AcceptanceHistoryDetail.vue?vue&type=script&lang=ts"

import "./AcceptanceHistoryDetail.vue?vue&type=style&index=0&id=93bab6fc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-93bab6fc"

export default script